<div class="container-fluid sell_dash">
    <div class="wrapper">
        <div class="row">
          <app-sidemenu></app-sidemenu> 
          <section class="right">
            <app-sellheader></app-sellheader>
            <div class="right-middle row justify-content-center">
       <div class="col-lg-12 col-xl-12">
        <embed src="./assets/sample.pdf" type="application/pdf" width="95%" height="540" class="ml-2" />
       </div>
            </div>
        </section>   
        <!-- begin::Sticky Toolbar -->
      <app-stickytoolbar></app-stickytoolbar>
          <!-- end::Sticky Toolbar -->       
       </div>
    </div>
</div>

